/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { t } from '@superset-ui/core';

export const PAGE_SIZE = 25;
export const SORT_BY = [{ id: 'changed_on_delta_humanized', desc: true }];
export const PASSWORDS_NEEDED_MESSAGE = t(
	'The passwords for the databases below are needed in order to ' +
		'import them together with the datasets. Please note that the ' +
		'"Secure Extra" and "Certificate" sections of ' +
		'the database configuration are not present in export files, and ' +
		'should be added manually after the import if they are needed.',
);
export const CONFIRM_OVERWRITE_MESSAGE = t(
	'You are importing one or more datasets that already exist. ' +
		'Overwriting might cause you to lose some of your work. Are you ' +
		'sure you want to overwrite?',
);
